import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';

declare var bootbox:any;

@Component({
  selector: 'app-sub-categories',
  template: require('./sub-categories.component.html')
})
export class SubCategoriesComponent extends BaseComponent implements OnInit {

  public subcategories = [];

  ngOnInit() {
    this.loadSubCategories();
  }

  public loadSubCategories() {
    this.busy = this.lsApi.getSubCategories().subscribe(resp => {
        if(resp.status) {
            this.subcategories = resp.data;
            //this.router.navigate([this.router.url]);
        }
    },
    error => {
        console.log(error);
    });
  }

  public deleteSubCategories(cat) {
    
    
    bootbox.confirm({message:"Do you want to delete '" + cat.name + "' sub-category and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteSubCategoryById(cat.subCategoryId).subscribe(resp => {
              if(resp.status) {
                  this.appToast.success("Sub-Category Successfully Deleted","Sub-Category Deleted");
                  this.loadSubCategories();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/sub-categories/sub-categories.component.ts